import image from "../assets/image.png";
import { useNavigate } from "react-router-dom";
import { Button, Typography, Space, Card, Row, Col, App } from "antd";
import {
  UserOutlined,
  ApiOutlined,
  PlusOutlined,
  DeleteOutlined,
  BookOutlined,
  CodeOutlined,
  CloudOutlined,
} from "@ant-design/icons";
import DashboardLayout from "./DashboardLayout";

const { Title, Text } = Typography;

const Admin = () => {
  const { message } = App.useApp();
  const navigate = useNavigate();
  const userRole = localStorage.getItem("user_role") || "client";

  // Base menu items available to all users
  const baseMenuItems = [
    {
      key: "api-docs",
      label: "API Documentation",
      icon: <BookOutlined />,
      onClick: () => navigate("/documentation"),
      color: "#722ed1", // Purple
    },
    {
      key: "rest-query-builder",
      label: "REST API Query Builder",
      icon: <CodeOutlined />,
      onClick: () => navigate("/rest-query-builder"),
      color: "#fa8c16", // Orange
    },
    {
      key: "s3-files",
      label: "S3 File Manager",
      icon: <CloudOutlined />,
      onClick: () => navigate("/s3-files"),
      color: "#13c2c2", // Cyan/teal
    },
  ];

  // Admin-only menu items
  const adminMenuItems = [
    {
      key: "users",
      label: "View Existing User",
      icon: <UserOutlined />,
      onClick: () => navigate("/users"),
      color: "#0066ff", // Blue
    },
    {
      key: "api-collection",
      label: "View APIs Collections",
      icon: <ApiOutlined />,
      onClick: () => navigate("/api-collection"),
      color: "#00d9ff", // Cyan
    },
    {
      key: "add-user",
      label: "Add New User",
      icon: <PlusOutlined />,
      onClick: () => navigate("/add-user"),
      color: "#52c41a", // Green
    },
    {
      key: "delete-rc",
      label: "Delete RC Record",
      icon: <DeleteOutlined />,
      onClick: () => navigate("/rc/delete"),
      danger: true, // Red
    },
  ];

  // Combine menu items based on role
  const menuItems =
    userRole === "admin"
      ? [...adminMenuItems, ...baseMenuItems]
      : baseMenuItems;

  const dashboardTitle =
    userRole === "admin" ? "Admin Dashboard" : "Client Dashboard";

  return (
    <DashboardLayout title={dashboardTitle}>
      <Row gutter={[48, 48]} align="middle">
        <Col xs={24} md={12}>
          <Space orientation="vertical" size="large" style={{ width: "100%" }}>
            <Title
              level={1}
              style={{
                margin: 0,
                color: "#0a1629",
                fontSize: "42px",
                fontWeight: 700,
                lineHeight: 1.2,
              }}
            >
              Streamlined KYC Solutions{" "}
              <Text
                style={{
                  fontSize: "32px",
                  background:
                    "linear-gradient(135deg, #0066ff 0%, #0052cc 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  fontWeight: 600,
                }}
              >
                for PAN and Aadhaar Verification
              </Text>
            </Title>
            <Text
              style={{
                fontSize: "16px",
                color: "#6b7a99",
                lineHeight: 1.7,
              }}
            >
              {userRole === "admin"
                ? "We provide digital infrastructure for managing users, verifying identities, and ensuring secure access across platforms."
                : "Access API documentation and build queries to interact with our verification services."}
            </Text>
            {userRole === "client" && (
              <Text
                style={{
                  fontSize: "14px",
                  color: "#0066ff",
                  lineHeight: 1.7,
                  fontStyle: "italic",
                }}
              >
                You have access to API Documentation and Query Builder tools.
              </Text>
            )}
            <Space wrap size="middle">
              {menuItems.map((item) => (
                <Button
                  key={item.key}
                  danger={item.danger}
                  icon={item.icon}
                  size="large"
                  onClick={item.onClick}
                  style={{
                    borderRadius: 8,
                    fontWeight: 600,
                    height: "44px",
                    padding: "0 24px",
                    background: item.danger
                      ? "linear-gradient(135deg, #ff3366 0%, #cc1a4d 100%)"
                      : `linear-gradient(135deg, ${item.color} 0%, ${item.color}dd 100%)`,
                    border: "none",
                    color: "white",
                    boxShadow: item.danger
                      ? "0 4px 12px rgba(255, 51, 102, 0.3)"
                      : `0 4px 12px ${item.color}40`,
                  }}
                >
                  {item.label}
                </Button>
              ))}
            </Space>
          </Space>
        </Col>

        <Col xs={24} md={12}>
          <Card
            style={{
              borderRadius: 16,
              overflow: "hidden",
              boxShadow: "0 8px 32px rgba(0, 102, 255, 0.12)",
              border: "1px solid #e1e8f0",
            }}
            styles={{ body: { padding: 0 } }}
          >
            <img
              src={image}
              alt="Company"
              style={{
                width: "100%",
                height: "auto",
                display: "block",
              }}
            />
          </Card>
        </Col>
      </Row>
    </DashboardLayout>
  );
};

export default Admin;
